export const allEmployeesOptionValue = -1;

export const allChairRenters = -2;

export const allFullTimeEmployees = -3;
